import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import Modal from "../modal";
import Button from "../button";
import IconClose from "../icons/close";
import Accordion from "../../screens/Info/Accordion";
import IconArrow from "../../components/icons/arrow";
import { loadFaq } from "../../redux/actions/faq";
import { changeMobileFaq, changeFaq } from "../../redux/actions/options";

class FaqModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAccordion: "",
            showLoading: true,
        };

        this._onAccordionPress = this._onAccordionPress.bind(this);
        this._onClose = this._onClose.bind(this);
    }

    componentDidMount() {
        this.props.loadFaq();
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.setState({
                showLoading: !this.props.space,
            });
        } else if (!this.props.visible && prevProps.visible) {
            this.setState({
                showLoading: false,
            });
        }
    }

    _onClose() {
        this.props.changeFaq(false);
    }

    _onAccordionPress(id) {
        this.setState({
            currentAccordion: id === this.state.currentAccordion ? "" : id,
        });
    }

    render() {
        const { visible, theme, faqData } = this.props;
        const { currentAccordion } = this.state;

        let textColor = "text-orange";
        let buttonBackgroundColor = "bg-orange";
        let buttonTextColor = "text-white";
        let borderColor = "border-orange";

        if (!faqData || faqData.length === 0) return null;

        let faqDataTheme = faqData[theme];

        if (!faqDataTheme) return null;

        return (
            <Modal
                visible={visible}
                maxWidth={"xl:max-w-5xl"}
                closeWithOverlay
                onClose={this._onClose}
            >
                <div
                    className="flex flex-col h-max p-32 bg-maize rounded"
                    style={{ minHeight: "200px" }}
                >
                    <div className="flex mb-40">
                        <div className="flex-1">
                            <p className="font-judge font-bold text-30 text-orange">
                                {"FAQS"}
                            </p>
                        </div>
                        <Button
                            icon={
                                <IconClose
                                    className={
                                        "w-20 h-20 md:w-25 md:h-25 z-10 transition hover-hover:group-hover:" +
                                        buttonTextColor +
                                        " " +
                                        textColor
                                    }
                                />
                            }
                            backgroundColorOver={buttonBackgroundColor}
                            borderColor={borderColor}
                            onClick={this._onClose}
                            style="w-50 md:w-70"
                            height="h-32 md:h-46"
                        />
                    </div>
                    <div className="overflow-scroll h-380">
                        {faqDataTheme.content.map((item) => (
                            <Accordion
                                id={item.key}
                                key={item.key}
                                section={item.attributes}
                                current={currentAccordion}
                                onPress={this._onAccordionPress}
                            />
                        ))}
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    visible: state.options.isFaqVisible,
    faqData: state.faq.data,
    theme: state.options.faqTheme,
    isLoading: state.faq.isLoading,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeFaq,
            changeMobileFaq,
            loadFaq,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(FaqModal);
